module.exports = __webpack_public_path__ + "assets/img/theX-content-defalut.5ba7d73a.png";